import { useMutation } from "@tanstack/react-query";
import api from "@lib/api/axios";
import { MutationConfig } from "@lib/api/query";
import { apiEnum } from "@shared/types/enums/apiEnum";

type PayLoadType = {
    name?: string;
    subject?: string;
    organizerEmail: string;
    organizerName: string;
    guid: string;
    ressourceId: number; // id vr resource
    resourceIds: string; // id reource child
    childResourcesEmail: string[];
    startDate: string;
    endDate: string;
    uid: string;
    isRecurring: number;
    busyStatus: string;
    orderStatus: string;
    isFromWebAddin: boolean;
    status: string;
};

const createTemp = async (payload: PayLoadType) => {
    const { data } = await api.post(apiEnum.createTemp, payload);
    return data;
};

type CreateTempType = {
    mutationConfig?: MutationConfig<typeof createTemp>;
};

export const useCreateTemp = ({ mutationConfig }: CreateTempType) => {
    return useMutation({
        ...mutationConfig,
        mutationFn: createTemp,
    });
};